import { OBJECT_getInstancerq52wx6ymebx as OBJECT_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_displayName1tigg9iilbqpf as get_displayName } from './Annotations.mjs';
import { text189ciz0cnr32o as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import {
  labeledForm2ame2d0a5lql9 as labeledForm,
  labeledView3rpvir7z2o9ii as labeledView,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerSingletonObject(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, VOID, OBJECT_getInstance()), ObjectRenderer_instance);
}
function ObjectRenderer$form$lambda(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Frame())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function ObjectRenderer$cellForm$lambda(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Frame())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return Unit_instance;
}
var ObjectRendererClass;
function ObjectRenderer() {
  if (ObjectRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Object';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_28tizu_k$(context, module_0) {
        return equals(context.serializer_1.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), OBJECT_getInstance()) ? 1.0 : -1.0;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_28tizu_k$(context, module_0);
      }
      columnWidth_g6s04q_k$(context, module_0) {
        return 10.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_g6s04q_k$(context, module_0);
      }
      form_klw3k6_k$(context, value, module_0) {
        return ObjectRenderer$form$lambda;
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_klw3k6_k$(context, value, module_0);
      }
      view_3m91zp_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          text(_this__u8e3s4, get_displayName(context));
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_3m91zp_k$(context, value, module_0);
      }
      cellView_hcodjr_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          text(_this__u8e3s4, get_displayName(context));
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_hcodjr_k$(context, value, module_0);
      }
      cellForm_ks8aws_k$(context, value, module_0) {
        return ObjectRenderer$cellForm$lambda;
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_ks8aws_k$(context, value, module_0);
      }
    }
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'ObjectRenderer', VOID, VOID, [Renderer()]);
    ObjectRendererClass = $;
  }
  return ObjectRendererClass;
}
var ObjectRenderer_instance;
function ObjectRenderer_getInstance() {
  return ObjectRenderer_instance;
}
//region block: init
ObjectRenderer_instance = new (ObjectRenderer())();
//endregion
//region block: exports
export {
  registerSingletonObject as registerSingletonObject3kqw43jd6n61l,
};
//endregion

//# sourceMappingURL=ObjectRenderer.mjs.map
